const checkMatchRegexp = (string: string, regExp: RegExp) => Boolean(string.match(regExp));
const checkTestRegexp = (string: string, regExp: RegExp) => regExp.test(string);

const searchRegexpIdx = (string: string, regExp: RegExp) => string.search(regExp);

export const LATIN_REGEXP = /[a-zA-Z]+/u;
export const CYRILLIC_NAME_REGEXP = /^[А-Яа-яЁё]+(?:-[А-Яа-яЁё]+)*(?:\s+[А-Яа-яЁё]+(?:-[А-Яа-яЁё]+)*)*$/u;
export const EMAIL_REGEXP = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/u;
const phoneReplacingRegExp = /[_+ ()\-]/gu;
const notLetter = /[?.,;!¡¿。、·\s]/u;
const letter = /[\d\u0400-\u04FFa-zA-Z]/u;

export const captureUrlIdRegExp = /-[0-9]+$/gu;

const isSpaceRegExp = /^\s$/gu;

/**
 *
 * @param phone строка, которую надо очистить от посторонних символов
 * @returns номер телефона без знаков +, _, " "
 */
export const formatPhone = (phone = ''): string => {
    return phone.replace(phoneReplacingRegExp, '');
};

/**
 *
 * @param phone строка, которую надо привести к виду маски
 * @returns номер телефона
 */
export const formatToPhoneMask = (phone = ''): string => {
    return phone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/u, '+$1 ($2) $3-$4-$5');
};

export const formatToFooterPhone = (phone = ''): string => {
    return phone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/u, '+$1 $2 $3 $4 $5');
};

/**
 *
 * @param string строка, которую надо проверить
 * @returns строка является Email
 */
export const checkIsEmail = (string: string) => checkTestRegexp(string, EMAIL_REGEXP);

export const checkIsSpace = (string: string) => checkMatchRegexp(string, isSpaceRegExp);
export const checkIsLetter = (string: string) => checkTestRegexp(string, letter);
export const searchNotLetterIdx = (string: string) => searchRegexpIdx(string, notLetter);
export const searchLetterIdx = (string: string) => searchRegexpIdx(string, letter);
